import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import values from 'lodash/values';
import LicensingModal from '../LicensingModal';
import OnboardingModal from '../OnboardingModal';
import { MODAL } from '../../constants';

class ModalConductor extends React.PureComponent {
  static propTypes = {
    currentModal: PropTypes.oneOf([...values(MODAL), undefined]),
  };

  render() {
    const { currentModal, ...otherProps } = this.props;

    switch (currentModal) {
      case MODAL.ONBOARDING:
        return <OnboardingModal {...otherProps} />;
      case MODAL.LICENSE_CLIP:
        return <LicensingModal {...otherProps} />;
      default:
        return null;
    }
  }
}

function mapStateToProps(state) {
  return { currentModal: state.modal.modal };
}

export default connect(mapStateToProps)(ModalConductor);



// WEBPACK FOOTER //
// ./src/containers/ModalConductor/ModalConductor.js